module.exports = __webpack_public_path__ + "img/logo.a66ebfd9.png";